// Configure and re-export generated API client
import { OpenAPI } from './generated';
import { AUTH_KEYS } from './axios-instance';

// Configure the generated API client
OpenAPI.BASE = process.env.REACT_APP_API_URL || 'https://api.clicklaw.tech/api/v1';
// OpenAPI.BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
OpenAPI.TOKEN = async () => {
  return localStorage.getItem(AUTH_KEYS.accessToken) || '';
};
OpenAPI.HEADERS = async () => ({
  'Accept': 'application/vnd.api.v1+json',
});

// Re-export all services
export {
  AuthenticationService,
  ClientsService,
  AppointmentsService,
  CaseTypesService,
  CitiesService,
  CountriesService,
  CourtCasesService,
  CourtsService,
  CourtTypesService,
  DepartmentsService,
  ExpensesService,
  FormsAndPrecedentsService,
  GeneralSettingsService,
  InvoicesService,
  JudgesService,
  StatesService,
  OpenAPI,
  ApiError,
} from './generated';

// Re-export axios instance and auth keys
export { axiosInstance, customInstance, AUTH_KEYS } from './axios-instance';

// Re-export query client
export { queryClient } from './query-client';
